import { ColumnSortInfo } from "../components/DataTable/PCDataTable";

export interface SortedField {
  id: string;
  field: string;
}

export type SortedFieldList = SortedField[];

export interface FieldOrder {
  id: string;
  field: string;
  fieldAsc: string;
  fieldDesc: string;
}

export type FieldOrderList = FieldOrder[];

/**
 * code
 * name
 * status
 * createdDate
 * lastModifiedDate
 * stoff.name
 * nichtstofflich.name
 * einheit.name
 * einheit.dimension.name
 * probenvorbehandlung.name
 * 
 */
class GraphQLUtilImpl {

  transformSortByList(sortBy?: ColumnSortInfo[]): any {
    return sortBy?.map(s => {
      return { field: s.id, direction: s.desc ? 'DESC': 'ASC'};
    });
  }

  /**
   * @deprecated
   * 
   * @param list 
   * @param sortBy 
   * @returns 
   */
  buildFieldList(list: FieldOrderList, sortBy?: ColumnSortInfo[]): SortedFieldList {
    const result: SortedFieldList = [];

    // add all sorted fields 
    sortBy?.forEach((e) => {
      const ordered = list.find((l) => l.id === e.id);
      if(ordered) {
        e.desc ? result.push({id: e.id, field: ordered.fieldDesc}) : result.push({id: e.id, field: ordered.fieldAsc});
      }
    });

    // add unsorted fields 
    list.forEach((e) => {
      const contains = result.find((r) => r.id === e.id);
      if(contains === undefined) {
        result.push({id: e.id, field: e.field});
      }
    });
    return result;
  }

  /**
   * @deprecated
   * 
   * @param fields
   * @returns 
   */
  transformSortedFieldsToString(fields: SortedFieldList): string {
    var result = '';
    fields.forEach((e) => {
      result = result.concat(e.field);
    })
    return result;
  }

}
export const GraphQLUtil = new GraphQLUtilImpl();
